import { GET_ASSIGNEES_SUCCESS, GET_ASSIGNEES_INFINITE_SUCCESS } from './filterPanelActionTypes';

export function filterReducer(state = null, action = {}) {
  switch (action.type) {
    case GET_ASSIGNEES_SUCCESS: {
      const { nextCursor, items, totalItems } = action.data;
      const options = state.prepareData(items);
      return { ...state, nextCursor, options, totalOptions: totalItems };
    }
    case GET_ASSIGNEES_INFINITE_SUCCESS: {
      const { nextCursor, items, totalItems } = action.data;
      const options = state.prepareData(items);
      return {
        ...state,
        nextCursor,
        options: [...state.options, ...options],
        totalOptions: totalItems
      };
    }
    default:
      return state;
  }
}
const remapFilters = (filters, action, filterName) => {
  const remappedFilters = filters
    ? filters.map((filter) => {
        if (filter.name === filterName) return filterReducer(filter, action);
        return filter;
      })
    : [];
  return remappedFilters;
};

export default remapFilters;
